export type LandingSectionId = 'diferenciais' | 'monitoramento' | 'pricing' | 'faq'

export const LANDING_SECTION_IDS: LandingSectionId[] = ['diferenciais', 'monitoramento', 'pricing', 'faq']

export function scrollToLandingSection(id: LandingSectionId) {
  if (typeof document === 'undefined') return
  const el = document.getElementById(id)
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

export function parseLandingSectionId(value: string | null | undefined): LandingSectionId | null {
  if (!value) return null
  return LANDING_SECTION_IDS.includes(value as LandingSectionId) ? (value as LandingSectionId) : null
}

